import { Divider } from "@atoms"

import styles from "./SelectListGroupDivider.module.scss"

export default function SelectListGroupDivider() {
    return <Divider contrast="low" className={styles.divider} />
}
